import { Navigate } from "react-router-dom";
import { useAbility } from "@casl/react";
import { AbilityContext } from "../casl";

export const RouteNotMatch = () => {
  const ability = useAbility(AbilityContext);
  if (!ability.can("get", "systems")) {
    return <Navigate to="/no-system" />;
  }
  return <Navigate to={`/1/orders`} />;
};
